import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ImpersonationProvider } from "./context/ImpersonationContext";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Cases from "./pages/Cases";
import CaseDetail from "./pages/CaseDetail";
import NewCase from "./pages/NewCase";
import Calculator from "./pages/Calculator";
import JudgmentCalculator from "./pages/JudgmentCalculator";
import EditCase from "./pages/EditCase";
import Clients from "./pages/Clients";
import ClientDetail from "./pages/ClientDetail";
import Deadlines from "./pages/Deadlines";
import Intelligence from "./pages/Intelligence";
import Vault from "./pages/Vault";
import Billing from "./pages/Billing";
import Referrals from "./pages/Referrals";
import Offers from "./pages/Offers";
import Credits from "./pages/Credits";
import HelpLookup from "./pages/HelpLookup";
import AdminCreditors from "./pages/AdminCreditors";
import Eula from "./pages/Eula";
import Coverage from "./pages/Coverage";
import StateCoverageDetail from "./pages/StateCoverageDetail";
import Benchmarks from "./pages/Benchmarks";
import BenchmarkDetail from "./pages/BenchmarkDetail";
import PublicOffer from "./pages/PublicOffer";
import Layout from "./components/Layout";
import "./App.css";

function Protected({ children }) {
    const { user, loading } = useAuth();
    if (loading) return (
        <div className="min-h-screen flex items-center justify-center text-slate-500 font-sans">Loading…</div>
    );
    if (!user) return <Navigate to="/login" replace />;
    return <Layout>{children}</Layout>;
}

export default function App() {
    return (
        <AuthProvider>
            <ImpersonationProvider>
                <BrowserRouter>
                <Toaster position="top-right" richColors />
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/benchmarks" element={<Benchmarks />} />
                    <Route path="/benchmarks/:slug" element={<BenchmarkDetail />} />
                    <Route path="/coverage" element={<Coverage />} />
                    <Route path="/coverage/:slug" element={<StateCoverageDetail />} />
                    <Route path="/offer/:token" element={<PublicOffer />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/eula" element={<Eula />} />
                    <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
                    <Route path="/cases" element={<Protected><Cases /></Protected>} />
                    <Route path="/cases/new" element={<Protected><NewCase /></Protected>} />
                    <Route path="/cases/:id/edit" element={<Protected><EditCase /></Protected>} />
                    <Route path="/cases/:id" element={<Protected><CaseDetail /></Protected>} />
                    <Route path="/calculator" element={<Protected><Calculator /></Protected>} />
                    <Route path="/judgment-calculator" element={<Protected><JudgmentCalculator /></Protected>} />
                    <Route path="/clients" element={<Protected><Clients /></Protected>} />
                    <Route path="/clients/:id" element={<Protected><ClientDetail /></Protected>} />
                    <Route path="/deadlines" element={<Protected><Deadlines /></Protected>} />
                    <Route path="/intelligence" element={<Protected><Intelligence /></Protected>} />
                    <Route path="/vault" element={<Protected><Vault /></Protected>} />
                    <Route path="/billing" element={<Protected><Billing /></Protected>} />
                    <Route path="/referrals" element={<Protected><Referrals /></Protected>} />
                    <Route path="/offers" element={<Protected><Offers /></Protected>} />
                    <Route path="/credits" element={<Protected><Credits /></Protected>} />
                    <Route path="/help/lookup" element={<Protected><HelpLookup /></Protected>} />
                    <Route path="/admin/creditors" element={<Protected><AdminCreditors /></Protected>} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
                </BrowserRouter>
            </ImpersonationProvider>
        </AuthProvider>
    );
}
